<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <!--        <ion-buttons slot="end">-->
        <!--            <ion-button (click)="fetchPayment()">-->
        <!--                <ion-icon slot="icon-only" name="cash"></ion-icon>-->
        <!--            </ion-button>-->
        <!--        </ion-buttons>-->
        <ion-title>Payment</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>

    <ion-card>
<!--        <ion-item *ngIf="depositTemp.amountDue > 0">-->
<!--            <ion-label>Amount Due</ion-label>-->
<!--            <ion-text> {{ depositTemp.amountDue | currency: 'EUR' }} </ion-text>-->
<!--        </ion-item>-->

        <ion-item>
            <ion-label class="ion-text-wrap">
                <p>Amount Paid (Invoice Total):</p>
            </ion-label>
            <ion-input class="ion-text-end ion-no-padding" type="number" (ionChange)="calculateChange()"
                       (click)="updateAmountPaid(); $event.target.select()" [(ngModel)]="depositTemp.amount">
            </ion-input>
        </ion-item>

<!--        <ion-item>-->
<!--            <ion-label>Change Given</ion-label>-->
<!--&lt;!&ndash;            <ion-text> {{ depositTemp.change  | currency: 'EUR' }}</ion-text>&ndash;&gt;-->
<!--            <ion-input class="ion-text-end ion-no-padding" type="number"-->
<!--                       (click)="updateAmountPaid(); $event.target.select()" [(ngModel)]="depositTemp.change">-->
<!--            </ion-input>-->
<!--        </ion-item>-->

        <ion-item (click)="selectDate()">
            <ion-label>Date</ion-label>
            <ion-text> {{ depositTemp.date | date: 'dd/MM/yyyy' }} </ion-text>
        </ion-item>

        <ion-item>
            <ion-label position="floating">Payment Type</ion-label>
            <ion-select [(ngModel)]="depositTemp.type" [compareWith]="changeCashAccountOrPayment" interface="popover">
                <ion-select-option *ngFor="let payType of paymentMethods"
                                   [value]="payType">{{ payType.description }}</ion-select-option>
            </ion-select>
        </ion-item>

        <ion-item *ngIf="depositTemp.type.cod === 'V'">
            <ion-label position="floating">Expiry Date</ion-label>
            <ion-select [(ngModel)]="depositTemp.expiry" interface="popover">
                <ion-select-option *ngFor="let expMonth of expiryMonths"
                                   [value]="expMonth">{{ expMonth }}</ion-select-option>
            </ion-select>
        </ion-item>

        <ion-item>
            <ion-label position="floating">Cash Account</ion-label>
            <ion-select [(ngModel)]="depositTemp.cashAccount" [compareWith]="changeCashAccountOrPayment"
                        interface="popover">
                <ion-select-option *ngFor="let cashAcc of cashAccounts"
                                   [value]="cashAcc">{{ cashAcc.description }}</ion-select-option>
            </ion-select>
        </ion-item>

        <ion-item>
            <ion-label position="floating">Reference</ion-label>
            <ion-input [(ngModel)]="depositTemp.reference"></ion-input>
        </ion-item>

        <ion-item>
            <ion-label position="floating">Note</ion-label>
            <ion-input [(ngModel)]="depositTemp.note"></ion-input>
        </ion-item>
    </ion-card>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (click)="savePayment()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>


</ion-content>
